// Lista completa de dispositivos do Traccar
// Fonte: https://www.traccar.org/devices/

export const allTraccarDevices = [
  // J16 - Dispositivo personalizado
  { name: "J16", protocol: "gt06", port: "5023", category: "Veicular" },
  
  // Freematics
  { name: "Freematics Traccar Edition", protocol: "freematics", port: "5170", category: "Recomendado" },
  { name: "Freematics ONE+ Model A", protocol: "freematics", port: "5170", category: "Veicular" },
  { name: "Freematics ONE+ Model B", protocol: "freematics", port: "5170", category: "Veicular" },
  { name: "Freematics ONE+ Model H", protocol: "freematics", port: "5170", category: "Veicular" },
  
  // GPS103 Protocol
  { name: "TK103-2B", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "TK104", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "GPS-103", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "GPS-103-A", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "TW-MD1101", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "GPS102", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "GPS102B", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "GPS104", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "306A", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "TK-102B", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "GPS105B", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "Coban GPS106", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "Coban GPS107", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "Coban GPS301", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "Coban GPS302", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "Coban GPS303", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "Coban GPS304", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "Coban GPS305", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "Coban GPS306", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "A306", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "GPS303-G", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "Coban 303F", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "TK303B", protocol: "gps103", port: "5001", category: "Veicular" },
  { name: "TK303G", protocol: "gps103", port: "5001", category: "Veicular" },
  
  // TK103 Protocol
  { name: "EC-546", protocol: "tk103", port: "5002", category: "Veicular" },
  { name: "TT0024", protocol: "tk103", port: "5002", category: "Veicular" },
  { name: "T1024", protocol: "tk103", port: "5002", category: "Veicular" },
  { name: "T1080", protocol: "tk103", port: "5002", category: "Veicular" },
  { name: "T2024", protocol: "tk103", port: "5002", category: "Veicular" },
  { name: "T2124", protocol: "tk103", port: "5002", category: "Veicular" },
  { name: "T12", protocol: "tk103", port: "5002", category: "Veicular" },
  { name: "T4400", protocol: "tk103", port: "5002", category: "Veicular" },
  { name: "T8800", protocol: "tk103", port: "5002", category: "Veicular" },
  { name: "T15400", protocol: "tk103", port: "5002", category: "Veicular" },
  { name: "TK05", protocol: "tk103", port: "5002", category: "Veicular" },
  { name: "TK10", protocol: "tk103", port: "5002", category: "Veicular" },
  { name: "TK15", protocol: "tk103", port: "5002", category: "Veicular" },
  { name: "Kingneed TK20", protocol: "tk103", port: "5002", category: "Veicular" },
  { name: "T18", protocol: "tk103", port: "5002", category: "Veicular" },
  { name: "T18H", protocol: "tk103", port: "5002", category: "Veicular" },
  { name: "T16", protocol: "tk103", port: "5002", category: "Veicular" },
  { name: "P168", protocol: "tk103", port: "5002", category: "Veicular" },
  { name: "P169", protocol: "tk103", port: "5002", category: "Veicular" },
  { name: "TK206", protocol: "tk103", port: "5002", category: "Veicular" },
  { name: "TK207", protocol: "tk103", port: "5002", category: "Veicular" },
  { name: "KS168", protocol: "tk103", port: "5002", category: "Veicular" },
  { name: "Kingneed", protocol: "tk103", port: "5002", category: "Veicular" },
  
  // GL100/GL200 Protocol
  { name: "GL100", protocol: "gl100", port: "5003", category: "Portátil" },
  { name: "GL100M", protocol: "gl200", port: "5004", category: "Portátil" },
  { name: "GL200", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GV300N", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GT200", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GT300", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GT500", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GL300", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GL3000W Series", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GL300VC", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GL300W Series", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GL500", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GL505", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GL520", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GT301", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GB100", protocol: "gl200", port: "5004", category: "Portátil" },
  { name: "GB100MG", protocol: "gl200", port: "5004", category: "Portátil" },
  { name: "GMT100", protocol: "gl200", port: "5004", category: "Portátil" },
  { name: "GMT200", protocol: "gl200", port: "5004", category: "Portátil" },
  { name: "GS100", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GV200", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GV300", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GV300VC", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GV300W", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GV500", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GV500VC", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GV50LTA", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GV55", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GV55 Lite", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GV55VC", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GV600W", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GV65", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GV65 Plus", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GV75", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GV75W", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "Prime AT Plus", protocol: "gl200", port: "5004", category: "Veicular" },
  { name: "GV500MAP", protocol: "gl200", port: "5004", category: "Veicular" },
  
  // T55 Protocol
  { name: "Gelix", protocol: "t55", port: "5005", category: "Veicular" },
  { name: "Gelix-2", protocol: "t55", port: "5005", category: "Veicular" },
  { name: "GPS-911(M)", protocol: "t55", port: "5005", category: "Veicular" },
  { name: "AVL-900", protocol: "t55", port: "5005", category: "Veicular" },
  { name: "AVL-900(R)", protocol: "t55", port: "5005", category: "Veicular" },
  { name: "AVL-900(M)", protocol: "t55", port: "5005", category: "Veicular" },
  { name: "AVL-901(B)", protocol: "t55", port: "5005", category: "Veicular" },
  { name: "AVL-901(C)", protocol: "t55", port: "5005", category: "Veicular" },
  { name: "AVL-901(D)", protocol: "t55", port: "5005", category: "Veicular" },
  { name: "AVL-921", protocol: "t55", port: "5005", category: "Veicular" },
  { name: "CradlePoint IBR600", protocol: "t55", port: "5005", category: "Industrial" },
  { name: "CradlePoint IBR1100", protocol: "t55", port: "5005", category: "Industrial" },
  { name: "Aspicore", protocol: "t55", port: "5005", category: "Veicular" },
  { name: "MultiConnect rCell", protocol: "t55", port: "5005", category: "Industrial" },
  
  // GT06 Protocol
  { name: "GT06", protocol: "gt06", port: "5023", category: "Veicular" },
  { name: "GT06N", protocol: "gt06", port: "5023", category: "Veicular" },
  { name: "Concox GT06E", protocol: "gt06", port: "5023", category: "Veicular" },
  { name: "VT200", protocol: "gt06", port: "5023", category: "Veicular" },
  
  // Teltonika
  { name: "Teltonika FMB920", protocol: "teltonika", port: "5027", category: "Premium" },
  { name: "Teltonika FMB120", protocol: "teltonika", port: "5027", category: "Veicular" },
  { name: "Teltonika FMB125", protocol: "teltonika", port: "5027", category: "Veicular" },
  { name: "Teltonika FMB130", protocol: "teltonika", port: "5027", category: "Veicular" },
  { name: "Teltonika FMB140", protocol: "teltonika", port: "5027", category: "Premium" },
  { name: "Teltonika FMB204", protocol: "teltonika", port: "5027", category: "Premium" },
  { name: "Teltonika FMB640", protocol: "teltonika", port: "5027", category: "Premium" },
  { name: "Teltonika DualCam", protocol: "dualcam", port: "5232", category: "Premium" },
  
  // Suntech
  { name: "ST310U", protocol: "suntech", port: "5011", category: "Veicular" },
  { name: "ST340", protocol: "suntech", port: "5011", category: "Veicular" },
  { name: "ST901", protocol: "suntech", port: "5011", category: "Veicular" },
  
  // iStartek/Startek
  { name: "iStartek VT100", protocol: "startek", port: "5222", category: "Veicular" },
  { name: "iStartek VT100-L", protocol: "startek", port: "5222", category: "Veicular" },
  { name: "iStartek VT200", protocol: "startek", port: "5222", category: "Veicular" },
  { name: "iStartek VT200 L", protocol: "startek", port: "5222", category: "Veicular" },
  { name: "iStartek VT202", protocol: "startek", port: "5222", category: "Veicular" },
  { name: "iStartek VT206", protocol: "startek", port: "5222", category: "Veicular" },
  { name: "iStartek VT600", protocol: "startek", port: "5222", category: "Veicular" },
  { name: "iStartek VT900", protocol: "startek", port: "5222", category: "Veicular" },
  
  // Outros protocolos populares
  { name: "Xexun TK102", protocol: "xexun", port: "5006", category: "Veicular" },
  { name: "Xexun TK103", protocol: "xexun", port: "5006", category: "Veicular" },
  { name: "Xexun XT107", protocol: "xexun", port: "5006", category: "Veicular" },
  { name: "TT18 4G", protocol: "xexun2", port: "5233", category: "Veicular" },
  { name: "X01", protocol: "xexun2", port: "5233", category: "Veicular" },
  { name: "X02", protocol: "xexun2", port: "5233", category: "Veicular" },
  { name: "X03", protocol: "xexun2", port: "5233", category: "Veicular" },
  { name: "X04", protocol: "xexun2", port: "5233", category: "Veicular" },
  { name: "X05", protocol: "xexun2", port: "5233", category: "Veicular" },
  { name: "X06", protocol: "xexun2", port: "5233", category: "Veicular" },
  
  // OsmAnd (App móvel)
  { name: "Traccar Client (Android/iOS)", protocol: "osmand", port: "5055", category: "App Móvel" },
  
  // Navtelecom
  { name: "Signal S-2651", protocol: "navtelecom", port: "5221", category: "Industrial" },
  { name: "Signal S-2652", protocol: "navtelecom", port: "5221", category: "Industrial" },
  { name: "Signal S-2653", protocol: "navtelecom", port: "5221", category: "Industrial" },
  { name: "Signal S-2654", protocol: "navtelecom", port: "5221", category: "Industrial" },
  
  // Outros
  { name: "Galeb GS100", protocol: "gs100", port: "5223", category: "Veicular" },
  { name: "MAVLink Drones", protocol: "mavlink2", port: "5224", category: "Drone" },
  { name: "Mictrack B2316", protocol: "b2316", port: "5230", category: "Veicular" },
  { name: "GL601", protocol: "gl601", port: "5257", category: "Veicular" },
  { name: "GL601CEU", protocol: "gl601", port: "5257", category: "Veicular" },
  { name: "TrackerD-LS", protocol: "dragino", port: "5253", category: "LoRa" },
  { name: "TrackerD", protocol: "dragino", port: "5253", category: "LoRa" },
  { name: "LBT1", protocol: "dragino", port: "5253", category: "LoRa" },
  { name: "LGT92", protocol: "dragino", port: "5253", category: "LoRa" },
];

// Agrupa dispositivos por protocolo
export const getDevicesByProtocol = () => {
  const grouped = {};
  
  allTraccarDevices.forEach(device => {
    if (!grouped[device.protocol]) {
      grouped[device.protocol] = {
        protocol: device.protocol,
        port: device.port,
        devices: []
      };
    }
    grouped[device.protocol].devices.push(device);
  });
  
  return Object.values(grouped).sort((a, b) => 
    b.devices.length - a.devices.length
  );
};

// Retorna estatísticas
export const getDeviceStats = () => {
  const protocols = new Set(allTraccarDevices.map(d => d.protocol));
  const categories = new Set(allTraccarDevices.map(d => d.category));
  
  return {
    totalDevices: allTraccarDevices.length,
    totalProtocols: protocols.size,
    totalCategories: categories.size
  };
};

